import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    packageVersion: process.env.PACKAGE_VERSION || '0',
    isSignedIn: false,
    isInitialized: false,
    googleUser: null,
    updateTimeInterval: 3600000, // 3600000, // time in miliseconds, 3,600,000 = 1h
    gFilesMap: {},
    gFilesMetaMap: {},
    gDrivesMap: {},
    inProgressFileIds: {},
    selectedFolder: [],
    settings: {
      favorites: [],
      view: [],
      version: process.env.PACKAGE_VERSION || '0'
    },
    // nextPageTokenMeta: {}
    apiQueries: {}
  },
  getters: {
    appVersion: (state) => {
      return state.packageVersion
    },
    isFavorite: (state) => (fileId) => {
      return state.settings.favorites.find(x => x.id === fileId) !== undefined
    }
  },
  mutations: {
    setSignedInStatus (state, val) {
      state.isSignedIn = val
    },
    setInitializedStatus (state, val) {
      state.isInitialized = val
    },
    setGoogleUser (state, user) {
      state.googleUser = user
    },

    setFavoriteItem (state, val) {
      const item = state.settings.favorites.find(x => x.id === val.id)
      if (item) {
        item.name = val.name
        item.description = val.description
        // console.log('updated favourite item: ', val.id)
      } else {
        Vue.set(state.settings.favorites, state.settings.favorites.length, val)
        // console.log('added favourite item: ', val)
      }
      localStorage.setItem(`${state.googleUser.getId()}`, JSON.stringify(state.settings))
    },
    deleteFavoriteItem (state, val) {
      for (let i = state.settings.favorites.length - 1; i >= 0; i--) {
        if (state.settings.favorites[i].id === val) {
          Vue.delete(state.settings.favorites, i)
          break
        }
      }
      localStorage.setItem(`${state.googleUser.getId()}`, JSON.stringify(state.settings))
    },

    // initUserSettings from localstorage
    initUserSettings (state, val) {
      if (val == null) {
        val = {
          favorites: [],
          view: []
        }
      }
      state.settings = val
    },
    // initGFilesMetaMap from localstorage
    initGFilesMetaMap (state, val) {
      if (val == null) {
        val = {}
      }
      state.gFilesMetaMap = val
    },
    // initGFilesMetaMap from localstorage
    initGFilesMap (state, val) {
      if (val == null) {
        val = {}
      }
      state.gFilesMap = val
    },

    clearStore (state) {
      state.gFilesMap = {}
      state.gFilesMetaMap = {}
    },
    // updateRootChildren (state, val) {
    //   Vue.set(state.gFilesMap, val.id, val)
    //   Vue.set(state.gFilesMetaMap[val.id], 'children', val.children)
    //   Vue.set(state.gFilesMetaMap[val.id], 'lastUpdated', Date.now())
    //   localStorage.setItem('gFilesMap', JSON.stringify(state.gFilesMap))
    //   localStorage.setItem('gFilesMetaMap', JSON.stringify(state.gFilesMetaMap))
    // },
    addGDrive (state, val) {
      if (typeof val === 'string' || val instanceof String) {
        if (!Object.prototype.hasOwnProperty.call(state.gDrivesMap, val)) {
          state.gDrivesMap[val] = null
        }
      } else if (Object.prototype.hasOwnProperty.call(val, 'driveId')) {
        if (!Object.prototype.hasOwnProperty.call(state.gDrivesMap, val.driveId)) {
          Vue.set(state.gDrivesMap, val.driveId, (val.driveId === val.id) ? val : null)
        } else if (val.driveId === val.id) {
          Vue.set(state.gDrivesMap, val.driveId, val)
        }
      }
    },
    addGFile (state, val) {
      // check if it's a team drive
      // if (Object.prototype.hasOwnProperty.call(val, 'driveId') && !Object.prototype.hasOwnProperty.call(state.gDrivesMap, val.driveId)) {
      //   state.gDrivesMap[val.driveId] = (val.driveId === val.id) ? val : null
      // }
      this.commit('addGDrive', val)
      if (val.parents !== undefined && Object.prototype.hasOwnProperty.call(state.gFilesMap, val.id)) {
        // if cached, remove parents from old cached parents
        const cachedFile = state.gFilesMap[val.id]
        for (let i = 0; i < cachedFile.parents.length; i++) {
          if (!val.parents.includes(cachedFile.parents[i]) && Object.prototype.hasOwnProperty.call(state.gFilesMetaMap, cachedFile.parents[i])) {
            const index = state.gFilesMetaMap[cachedFile.parents[i]].children.indexOf(val.id)
            Vue.delete(state.gFilesMetaMap[cachedFile.parents[i]].children, index)
          }
        }
      }
      Vue.set(state.gFilesMap, val.id, val) // set file to gFilesMap
      if (val.parents !== undefined) {
        // add new parents
        for (let i = 0; i < val.parents.length; i++) {
          if (Object.prototype.hasOwnProperty.call(state.gFilesMap, val.parents[i]) && !state.gFilesMetaMap[val.parents[i]].children.includes(val.id)) {
            Vue.set(state.gFilesMetaMap[val.parents[i]].children, state.gFilesMetaMap[val.parents[i]].children.length, val.id)
          }
        }
      }
      if (!Object.prototype.hasOwnProperty.call(state.gFilesMetaMap, val.id)) {
        const obj = {
          children: (val.mimeType === 'application/vnd.google-apps.folder' || val.kind === 'drive#drive') ? [] : null,
          childrenStatus: 'none',
          lastUpdated: Date.now()
        }
        Vue.set(state.gFilesMetaMap, val.id, obj)
        // console.log('gFilesMap cache created - ', val.id)
      } else {
        // update lastUpdated time
        // console.log('gFilesMap cache updated - ', val.id, Date.now() - state.gFilesMetaMap[val.id].lastUpdated)
        Vue.set(state.gFilesMetaMap[val.id], 'lastUpdated', Date.now())
      }
      // localStorage.setItem('gFilesMap', JSON.stringify(state.gFilesMap))
      // localStorage.setItem('gFilesMetaMap', JSON.stringify(state.gFilesMetaMap))
    },
    setChildrenStatus (state, val) {
      state.gFilesMetaMap[val.id].childrenStatus = val.status
      // localStorage.setItem('gFilesMetaMap', JSON.stringify(state.gFilesMetaMap))
    },
    setApiListQueryMeta (state, val) {
      if (!Object.prototype.hasOwnProperty.call(state.apiQueries, val.q)) {
        state.apiQueries[val.q] = {}
      }
      if (Object.prototype.hasOwnProperty.call(val, 'nextPageToken')) state.apiQueries[val.q].nextPageToken = val.nextPageToken
      if (Object.prototype.hasOwnProperty.call(val, 'folders')) state.apiQueries[val.q].folders = val.folders
    },
    // setNextPageTokenMeta (state, val) {
    //   state.nextPageTokenMeta[val.nextPageToken] = val.value
    // }
    // setChildrenNextPageToken (state, val) {
    //   state.gFilesMetaMap[val.id].childrenNextPageToken = val.nextPageToken
    //   localStorage.setItem('gFilesMetaMap', JSON.stringify(state.gFilesMetaMap))
    // },
    // assignChildren (state, val) { // for assign children in getFilesInFolders
    //   Vue.set(state.gFilesMetaMap[val.parents[0]].children, state.gFilesMetaMap[val.parents[0]].children.length, val.id)
    //   localStorage.setItem('gFilesMetaMap', JSON.stringify(state.gFilesMetaMap))
    // },
    setSelectedFolder (state, val) {
      if (!state.selectedFolder.includes(val)) {
        Vue.set(state.selectedFolder, state.selectedFolder.length, val)
      }
    },
    deleteSelectedFolder (state, val) {
      const index = state.selectedFolder.indexOf(val)
      if (index > -1) {
        Vue.delete(state.selectedFolder, index)
      }
      // for (let i = state.selectedFolder.length - 1; i >= 0; i--) {
      //   if (state.selectedFolder[i].id === val) {
      //     Vue.delete(state.selectedFolder, i)
      //     break
      //   }
      // }
    },
    clearSelectedFolder (state, val) {
      state.selectedFolder = val || []
    },
    // store gridView info in database
    setView (state, val) {
      const objIndex = state.settings.view.findIndex(obj => obj.id === val.id)
      if (objIndex > -1) {
        Vue.set(state.settings.view[objIndex], 'view', val.view)
      } else {
        Vue.set(state.settings.view, state.settings.view.length, val)
      }
      localStorage.setItem(`${state.googleUser.getId()}`, JSON.stringify(state.settings))
    }
  },
  actions: {
  },
  modules: {
  }
})
